var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',_vm._b({staticClass:"ButtonSubmit",class:{long: _vm.long},attrs:{"loading":_vm.loading,"type":_vm.type},on:{"click":_vm.handleSubmit}},'el-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }